import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { getButton, updateButton, createButton } from "../../api/axios";
import CmsCircularProgress from "../Common/CircularProgress";
import { showToast } from "../../Utills/toast";
import FormGroup from "../Common/FormGroup";
import { Formik } from "formik";
import * as Yup from "yup";

const dropDownButtonPositionData = [
  { title: 'Select the button position', value: 0 },
  { title: 'Header Section', value: 'Header section' },
  { title: 'Bottom Section', value: 'Bottom section' },
];

const dropDownPageNameData = [
  { title: 'Select the page name', value: 0 },
  { title: 'Home', value: 'Home' },
  { title: 'For Business', value: 'For Business' },
  { title: 'For Individuals', value: 'For Individuals' },
  { title: 'About Us', value: 'About Us' },
];

// Validation schema
const validationSchema = Yup.object({
  pageName: Yup.string().required("Page name is required"),
  pagePosition: Yup.string().required("Page position is required"),
  button_name: Yup.string().required("Button name is required"),
  buttonLink: Yup.string().required("Button link is required"),
});

export default function ButtonsEdit() {
  const { id, partnerId } = useParams();
  const navigate = useNavigate();
  const [button, setButton] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [initialData, setInitialData] = useState({
    pageName: "",
    pagePosition: "",
    button_name: "",
    buttonLink: "",
  });

  const fetchButtonData = async (buttonId) => {
    setIsLoading(true);
    try {
      const response = await getButton(buttonId);
      const blogData = response?.data?.data[0];
      setButton(blogData);
      
      const formData = {
        pageName: blogData?.pageName || "",
        pagePosition: blogData?.pagePosition || "",
        button_name: blogData?.button_name || "",
        buttonLink: blogData?.buttonLink || "",
      };
      
      setInitialData(formData);
    } catch (error) {
      console.log(error);
      showToast({
        type: 'error',
        message: 'Failed to fetch button details. Please try again.',
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchButtonData(id);
  }, [id]);

  const handleSubmit = async (values, { setSubmitting }) => {
    const formData = {
      pageName: values.pageName,
      pagePosition: values.pagePosition,
      button_name: values.button_name,
      buttonLink: values.buttonLink,
    };

    try {
      let res;
      if (!Number(id)) {
        formData.partner_id = partnerId;
        res = await createButton(formData);
        if (res.status === 200) {
          showToast({
            type: 'success',
            message: 'Button has been created successfully!',
          });
          const blogData = res.data.data;
          setButton(blogData);
          navigate(`/${partnerId}/buttons/update/${blogData.id}`);
          console.log("success");
        } else {
          showToast({
            type: 'error',
            message: 'Failed to create button. Please try again.',
          });
        }
      } else {
        res = await updateButton(id, formData);
        if (res.status === 200) {
          showToast({
            type: 'success',
            message: 'Button has been updated successfully!',
          });
          console.log("success");
        } else {
          showToast({
            type: 'error',
            message: 'Failed to update button. Please try again.',
          });
        }
      }
    } catch (err) {
      console.log(err);
      showToast({
        type: 'error',
        message: !Number(id)
          ? 'Failed to create button. Please try again.'
          : 'Failed to update button. Please try again.',
      });
    } finally {
      setSubmitting(false);
    }
  };



  return (
    <>
    {isLoading ? <CmsCircularProgress/> :
    <FormWrapper>
      <Title>{!Number(id) ? "Create" : "Edit"} Buttons section</Title>
      <Formik
        initialValues={initialData}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize={true}
      >
        {({ handleSubmit, getFieldProps, setFieldValue, values, errors, touched, isSubmitting }) => (
          <Form onSubmit={handleSubmit} noValidate>
            <SliderDiv>
              <FormGroup 
                label='Page Name  (You cannot edit this field after creataion.)'
                requiredField
                error={touched.pageName && errors.pageName}
              >
                <SelectBox 
                  disabled={Number(id)} 
                  {...getFieldProps("pageName")}
                  isInvalid={touched.pageName && errors.pageName}
                >
                  {dropDownPageNameData?.map((option, index) => (
                    <option
                      key={index}
                      value={option.value}
                      selected={option.value == values.pageName}
                    >
                      {option?.title}
                    </option>
                  ))}
                </SelectBox>
              </FormGroup>
              
              <FormGroup 
                label='Position (You cannot edit this field after creataion.)'
                requiredField
                error={touched.pagePosition && errors.pagePosition}
              >
                <SelectBox 
                  disabled={Number(id)} 
                  {...getFieldProps("pagePosition")}
                  isInvalid={touched.pagePosition && errors.pagePosition}
                >
                  {dropDownButtonPositionData?.map((option, index) => (
                    <option
                      key={index}
                      value={option.value}
                      selected={option.value == values.pagePosition}
                    >
                      {option?.title}
                    </option>
                  ))}
                </SelectBox>
              </FormGroup>
              
              <FormGroup 
                label='Enter a new part 4'
                requiredField
                error={touched.button_name && errors.button_name}
              >
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Enter button name"
                  {...getFieldProps("button_name")}
                  isInvalid={touched.button_name && errors.button_name}
                />
              </FormGroup>
              
              <FormGroup 
                label='Enter a button link'
                requiredField
                error={touched.buttonLink && errors.buttonLink}
              >
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Enter button link"
                  {...getFieldProps("buttonLink")}
                  isInvalid={touched.buttonLink && errors.buttonLink}
                />
              </FormGroup>
              
              <ButtonWrapper className="mt-3">
                <Link to={`/${partnerId}/buttons`}>
                  <Button variant="secondary">Go Back</Button>
                </Link>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save Changes"}
                </Button>
              </ButtonWrapper>
            </SliderDiv>
          </Form>
        )}
      </Formik>
    </FormWrapper>}
    </>
  );
}

const SelectBox = styled.select`
  width: 100%;
  height: 45px;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 10px;
  font-size: 16px;
  background: white;
  outline: none;
`;
const FormWrapper = styled.div`
 @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
   @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
  gap: 1rem;
  }
`;
const SliderDiv = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
`;